import React from 'react';
import Button from './Button';

interface SubmitButtonProps {
  isLoading: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  loadingText?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const SubmitButton: React.FC<SubmitButtonProps> = ({
  isLoading,
  disabled = false,
  children,
  loadingText,
  className = '',
  type = 'submit',
}) => {
  return (
    <Button
      type={type}
      loading={isLoading}
      disabled={disabled}
      className={`w-full ${className}`}
    >
      {isLoading && loadingText ? loadingText : children}
    </Button>
  );
};

export default SubmitButton;
